import React from 'react'

const Spinner = () => {
  const style = {
    position: 'fixed',
    // zIndex: 999,
    margin: 'auto',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundImage: 'url(\'/static/images/diesel-loading.gif\')',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 100,
    backgroundColor: '#b3b3b3'
  }

  return (
    <div style={style}></div>
  )
}

Spinner.propTypes = {
}

export default Spinner
